import React from "react";
import { Link, useLocation } from "react-router-dom";
import { House, SquaresFour, CalendarCheck, ChatCircle } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";
import { readCity } from "@/components/LocationPicker";

const CHAT = { en: "Chat", nl: "Chat", pl: "Czat", it: "Chat", sk: "Chat", es: "Chat", pt: "Chat" };
const HOME = { en: "Home", nl: "Home", pl: "Główna", it: "Home", sk: "Domov", es: "Inicio", pt: "Início" };

export const TabBar = ({ onChat }) => {
  const { t, lang } = useLang();
  const { pathname } = useLocation();
  const city = readCity();

  const items = [
    { to: "/home", icon: House, label: HOME[lang] || HOME.en, id: "home" },
    {
      to: city && city !== "all" ? `/browse?city=${encodeURIComponent(city)}` : "/browse",
      base: "/browse",
      icon: SquaresFour,
      label: t("nav_browse"),
      id: "browse",
    },
    { to: "/dashboard", icon: CalendarCheck, label: t("nav_dashboard"), id: "dashboard" },
  ];

  return (
    <nav className="tab-bar fixed inset-x-0 bottom-0 z-50 flex items-center justify-between md:hidden" data-testid="mobile-tab-bar">
      {items.map(({ to, base, icon: Icon, label, id }) => {
        const active = pathname.startsWith(base || to);
        return (
          <Link
            key={id}
            to={to}
            data-testid={`tab-${id}`}
            className={`tab-item flex min-w-[52px] flex-col items-center gap-1 text-[10px] ${active ? "tab-item-active" : ""}`}
            style={{ color: active ? "#c6bff0" : "rgba(233,233,237,0.5)" }}
          >
            <Icon size={21} weight={active ? "fill" : "regular"} />
            {label}
          </Link>
        );
      })}
      <button
        type="button"
        onClick={onChat}
        data-testid="tab-chat"
        className="tab-item flex min-w-[52px] flex-col items-center gap-1 text-[10px]"
        style={{ color: "rgba(233,233,237,0.5)" }}
      >
        <ChatCircle size={21} />
        {CHAT[lang] || CHAT.en}
      </button>
    </nav>
  );
};
